module.exports = __webpack_public_path__ + "fonts/RenaultLifeOldStyle-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/old-style/RenaultLifeOldStyle-Bold.woff
// module id = 340
// module chunks = 0